/**
 * Encode and decode helpers for the Hekate playback sync wire protocol.
 * See web/docs/playback-sync-protocol.md for the full command table.
 */
export const CMD = {
    PLAY: 'KPLAY',
    PAUSE: 'KPAUSE',
    REW: 'KREW',
    FF: 'KFF',
    HOME: 'KHOME',
    FILE: 'KFILE',
    WAIT: 'KWAIT',
    READY: 'KREADY',
    ALLREADY: 'KALLREADY',
    CONNECT: 'KCONNECT',
    DISCONNECT: 'KDISCONNECT',
    NOTE: 'KNOTE',
    TCREQ: 'KTCREQ',
    PING: 'KPING',
    PONG: 'KPONG',
    SEEK_AT: 'KSEEK@',
    TC: 'TC',
    AB: 'AB',
};
/** `HH:MM:SS:FF`, always 11 chars. */
export const TIMECODE_LENGTH = 11;
export function encodeTimecode(timecode, absolute) {
    if (timecode.length !== TIMECODE_LENGTH) {
        throw new Error(`Timecode must be ${TIMECODE_LENGTH} chars (HH:MM:SS:FF), got "${timecode}"`);
    }
    return (absolute ? CMD.AB : CMD.TC) + timecode;
}
export function encodeSeekAt(timecode) {
    if (timecode.length !== TIMECODE_LENGTH) {
        throw new Error(`Timecode must be ${TIMECODE_LENGTH} chars, got "${timecode}"`);
    }
    return CMD.SEEK_AT + timecode;
}
export function encodeFileChange(fileId) {
    if (!Number.isFinite(fileId) || fileId <= 0) {
        throw new Error(`File id must be a positive number, got ${fileId}`);
    }
    return CMD.FILE + String(fileId);
}
export function parseMessage(raw) {
    // Order matters: check longest prefixes first.
    if (raw.startsWith(CMD.SEEK_AT)) {
        return { kind: 'seek', timecode: raw.slice(CMD.SEEK_AT.length, CMD.SEEK_AT.length + TIMECODE_LENGTH), absolute: true };
    }
    if (raw.startsWith(CMD.ALLREADY))
        return { kind: 'allready', raw };
    if (raw.startsWith(CMD.DISCONNECT))
        return { kind: 'disconnect', raw };
    if (raw.startsWith(CMD.CONNECT))
        return { kind: 'connect', raw };
    if (raw.startsWith(CMD.PAUSE))
        return { kind: 'pause', raw };
    if (raw.startsWith(CMD.PLAY))
        return { kind: 'play', raw };
    if (raw.startsWith(CMD.REW))
        return { kind: 'rew', raw };
    if (raw.startsWith(CMD.FF))
        return { kind: 'ff', raw };
    if (raw.startsWith(CMD.HOME))
        return { kind: 'home', raw };
    if (raw.startsWith(CMD.FILE)) {
        const idStr = raw.slice(CMD.FILE.length);
        const fileId = Number.parseInt(idStr, 10);
        if (!Number.isFinite(fileId) || fileId <= 0)
            return { kind: 'unknown', raw };
        return { kind: 'fileChange', fileId };
    }
    if (raw.startsWith(CMD.WAIT))
        return { kind: 'wait', raw };
    if (raw.startsWith(CMD.READY))
        return { kind: 'ready', raw };
    if (raw.startsWith(CMD.NOTE))
        return { kind: 'note', raw };
    if (raw.startsWith(CMD.TCREQ))
        return { kind: 'tcreq', raw };
    if (raw.startsWith(CMD.PING))
        return { kind: 'ping', raw };
    if (raw.startsWith(CMD.PONG))
        return { kind: 'pong', raw };
    if (raw.startsWith(CMD.AB)) {
        return { kind: 'seek', timecode: raw.slice(CMD.AB.length, CMD.AB.length + TIMECODE_LENGTH), absolute: true };
    }
    if (raw.startsWith(CMD.TC)) {
        return { kind: 'seek', timecode: raw.slice(CMD.TC.length, CMD.TC.length + TIMECODE_LENGTH), absolute: false };
    }
    return { kind: 'unknown', raw };
}
